// extracted by mini-css-extract-plugin
export var tosLink = "_6g-0";